import { todayIn } from "../../lib/finance";

export type IouDraft = {
  payeeId: string;
  /** Set when a new payee is kept locally until sync creates it. */
  payeeName?: string;
  direction: "Owed to us" | "We owe";
  originalAmount: string;
  description: string;
  createdDate: string;
  dueDate: string;
  fundingAccountId: string;
};
export type SettleDraft = { iouId: string; amount: string; accountId: string; notes: string };
export type LoanEditDraft = { description: string; originalAmount: string; dueDate: string; fundingAccountId: string };
export type PaymentEditDraft = { id: string; amount: string; date: string; accountId: string; notes: string };

// No currency field: the loan is denominated by the account the cash moves through, so letting
// one be typed here only ever made the IOU disagree with the transaction it wrote.
export const blankIou = (): IouDraft => ({ payeeId: "", direction: "Owed to us", originalAmount: "", description: "", createdDate: todayIn(), dueDate: "", fundingAccountId: "" });
